import React from "react";
import { Button } from "react-bootstrap";
import { getPubAbbr } from "@revbox/helpers-fe";
import { brendingActionButtons, advIntervalAuctionsBreadcrumbs } from "@revbox/localization";
import { TaxonomyModule } from "../../../../../modules/taxonomy";
import { getPathKey, useCookiesContext } from "../../../../../contexts/CookiesContext";
import Cookies from "universal-cookie";
import { cookiesKeyNames } from "@revbox/common-fe";

export function ActionRenderer({ value, data }) {
  const cookies = new Cookies()
  const pathKey = getPathKey()
  const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'

  if (!value) {
    return null;
  }

  if (data && data.auctionClose === 'Closed') {
    return <Button
            variant="outline"
            size="sm"
            className=""
            style={{ marginLeft: '0px', width: '130px' }}
            disabled
          >
            <i className="ri-lock-2-line me-1"></i>
            <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
              {brendingActionButtons[language].unavailable}
            </span>
          </Button>
  }

  const status = value.toUpperCase();

  if (status === "INACTIVE" || status === "DRAFT") {
    return (
      <button className="btn bg-success btn-sm text-white" style={{marginLeft: '5px', width: '100px'}}>
        {brendingActionButtons[language].startBidding}
      </button>
    );
  } else {
    return (
      <div>
        <Button variant="outline-primary" size="sm" className="" style={{marginLeft: '5px', width: '100px'}}>
          {brendingActionButtons[language].updateBid}
        </Button>
      </div>
    );
  }
}

export function ActionCellColumnHeaderTooltipRenderer() {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  return taxonomy.tooltips.ppc_specific_column_headers.action;
}

export function ActionCellTooltipRenderer({ value, data }) {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);
  const cookies = new Cookies()
  const pathKey = getPathKey()
  const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'
  
  if (!value) {
    return null;
  }
  
  if (data && data.auctionClose === 'Closed') {
    return advIntervalAuctionsBreadcrumbs[language].closedAuctionTooltip;
  }
  
  const status = value.toUpperCase();

  if (status === "INACTIVE" || status === "DRAFT") {
    return taxonomy.tooltips.ppc_specific_column_inlines.action.start_bidding;
  } else {
    return taxonomy.tooltips.ppc_specific_column_inlines.action.update_bid;
  }
}
  
